const masterEn = {
    country: require('lang/en/master/Country').default,
    state: require('lang/en/master/State').default,
    city: require('lang/en/master/City').default,
    chargesType: require('lang/en/master/ChargesType').default,
    charges: require('lang/en/master/Charges').default,
    checklist: require('lang/en/master/Checklist').default,
    serviceType: require('lang/en/master/ServiceType').default,
    serviceSubType: require('lang/en/master/ServiceSubType').default,
    deliveryPartner: require('lang/en/master/DeliveryPartner').default,
    expenseType: require('lang/en/master/ExpenseType').default,
    noticeType: require('lang/en/master/NoticeType').default,
};

export default masterEn;